import getSingleItemProductString from "../getSingleItemProductString";
import getEvents from "./getEvents";
import { ADD_ITEM_TO_BAG_ACTION } from "../constants";
import {
  ADOBE_PRODUCTS_KEY,
  ADOBE_WISHLIST_ACTION_KEY
} from "../../../../../../services/analytics/constants";

export const addItemToBag = (state, { payload: { variantId, price } }) => ({
  ...state,
  trackLink: {
    products: getSingleItemProductString({ variantId, quantity: 1, price }),
    wishlistAction: ADD_ITEM_TO_BAG_ACTION,
    events: getEvents({ price }),
    vars: [ADOBE_WISHLIST_ACTION_KEY, ADOBE_PRODUCTS_KEY]
  }
});
